import { cn } from "@/lib/utils";
import { Tabs as RadixTabs } from "@radix-ui/themes";
import {
  Tabs as DataTabs,
  TabsList as DataTabsList,
  TabsTrigger as DataTabsTrigger,
  TabsContent as DataTabsContent,
} from "../dataTabs/tabs";
import { ReactNode } from "react";

export interface TabItem {
  value: string;
  label?: string;
  icon?: ReactNode;
  disabled?: boolean;
}

interface TabsProps {
  variant?: "default" | "data";
  tabs: TabItem[];
  value?: string;
  onValueChange?: (value: string) => void;
  fullWidth?: boolean;
}

export function Tabs({
  variant = "default",
  tabs,
  value,
  onValueChange,
  fullWidth = false,
}: TabsProps) {
  if (variant === "data") {
    return (
      <DataTabs value={value} onValueChange={onValueChange}>
        <DataTabsList fullWidth={fullWidth}>
          {tabs.map((tab) => (
            <DataTabsTrigger
              key={tab.value}
              value={tab.value}
              fullWidth={fullWidth}
            >
              {tab.icon}
              {tab.label}
            </DataTabsTrigger>
          ))}
        </DataTabsList>
      </DataTabs>
    );
  }

  return (
    <RadixTabs.Root
      value={value}
      onValueChange={onValueChange}
      className={cn(fullWidth && "w-full")}
    >
      <RadixTabs.List className={cn(fullWidth && "w-full")}>
        {tabs.map((tab) => (
          <RadixTabs.Trigger
            key={tab.value}
            value={tab.value}
            disabled={tab.disabled}
          >
            {tab.icon}
            {tab.label}
          </RadixTabs.Trigger>
        ))}
      </RadixTabs.List>
    </RadixTabs.Root>
  );
}

// Export the original Radix components for direct access if needed
export { RadixTabs };
